var map = {
	"./安全保障-bg.jpg": "78e2",
	"./安全培训-bg.jpg": "6863",
	"./安全巡检-bg.jpg": "8396",
	"./应急处理-bg.jpg": "f186",
	"./攻防演练-bg.jpg": "3584",
	"./渗透测试-bg.jpg": "b865",
	"./风险评估-bg.jpg": "7513"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "464b";